module.exports = __webpack_public_path__ + "img/faq.67bec061.webp";